import * as React from 'react';
import { ListPage } from '../../../ui';
import { MyClaimsList } from './index';

class MyClaimsListPage extends React.PureComponent {
  render() {
    return (
      <ListPage>
        <MyClaimsList/>
      </ListPage>
    );
  }
}

export default MyClaimsListPage;
